import React from "react";
import { usePermissions } from "../../context/PermissionProvider";
import { CircularProgress, Box, Typography } from "@mui/material";

/**
 * Higher-Order Component to protect routes based on permissions
 * @param {React.Component} Component - The component to protect
 * @param {string} module - The module name (e.g., "employee", "taskManagement")
 * @param {string} action - The action required (e.g., "view", "add", "edit", "delete")
 */
const withPermission = (Component, module, action = "view") => {
  return (props) => {
    const { hasPermission, loading } = usePermissions();

    if (loading) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress />
        </Box>
      );
    }

    if (!hasPermission(module, action)) {
      return (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            gap: 2,
          }}
        >
          <Typography variant="h4" color="error">
            Access Denied
          </Typography>
          <Typography variant="body1" color="textSecondary">
            You don't have permission to access this page.
          </Typography>
        </Box>
      );
    }

    return <Component {...props} />;
  };
};

export default withPermission;
